/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Conversations_YetInputs */

const en_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet`)
};

const es_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay conversaciones`)
};

const fr_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation pour le moment`)
};

const de_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Unterhaltungen`)
};

const ja_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだメッセージはありません`)
};

const zh_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无对话`)
};

const ar_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد محادثات بعد`)
};

const id_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada percakapan`)
};

const it_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna conversazione`)
};

const ru_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет сообщений`)
};

const pt_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conversa ainda`)
};

const ko_no_conversations_yet = /** @type {(inputs: No_Conversations_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 대화가 없습니다`)
};

/**
* | output |
* | --- |
* | "No conversations yet" |
*
* @param {No_Conversations_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_conversations_yet = /** @type {((inputs?: No_Conversations_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Conversations_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_conversations_yet(inputs)
	if (locale === "es") return es_no_conversations_yet(inputs)
	if (locale === "fr") return fr_no_conversations_yet(inputs)
	if (locale === "de") return de_no_conversations_yet(inputs)
	if (locale === "ja") return ja_no_conversations_yet(inputs)
	if (locale === "zh") return zh_no_conversations_yet(inputs)
	if (locale === "ar") return ar_no_conversations_yet(inputs)
	if (locale === "id") return id_no_conversations_yet(inputs)
	if (locale === "it") return it_no_conversations_yet(inputs)
	if (locale === "ru") return ru_no_conversations_yet(inputs)
	if (locale === "pt") return pt_no_conversations_yet(inputs)
	return ko_no_conversations_yet(inputs)
});